import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminPortal from "./components/AdminPortal";
import UserDashboard from "./components/UserDashboard";
import Login from "./components/Login";
import UserManager from "./components/UserManager"; // <-- import UserManager

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) setUser(storedUser);
    setLoading(false);
  }, []);

  if (loading) return <div>Loading...</div>; // Optional loader while checking localStorage

  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login setUser={setUser} />} />

        {/* Admin routes */}
        <Route
          path="/admin"
          element={user?.role === "admin" ? <AdminPortal /> : <Navigate to="/login" />}
        />
        <Route
          path="/admin/user-manager"
          element={user?.role === "admin" ? <UserManager /> : <Navigate to="/login" />}
        />

        {/* User routes */}
        <Route
          path="/user"
          element={user?.role === "user" ? <UserDashboard user={user} /> : <Navigate to="/login" />}
        />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}
